module.exports = __webpack_public_path__ + "static/media/nodata-icon.b66d053e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nodata-icon.svg
// module id = 46
// module chunks = 0